(function () {
  /**
   * @ngdoc service/provider
   * @name jilResellers
   * @description defines service to manage jil resellers resources
   */
  angular.module('app.core.api.jil').provider('jilResellers', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/resellers`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        resellerChange: resellerChange(),
        resellers: getResellersResource(),
      };

      return service;

      ///////////

      function getResellersResource() {
        return $resource(`${url}/:id`, {
          id: '@id',
        });
      }

      function resellerChange() {
        const customers = `customers/customer:change`;
        const completeURL = `${url}/:resellerId/${customers}`;
        return $resource(`${completeURL}`, {
          change: '@change',
          id: '@id',
          resellerId: '@resellerId',
        });
      }
    }
  }
})();
